import React, { useState } from 'react';
import './../../entrydoor.css';

const TransomOnLoose = ({ value, onChange, label = 'Transom On/Loose' }) => {
    const [selectedTransomOnLoose, setSelectedTransomOnLoose] = useState(value || "");

    const handleTransomOnLooseChange = (e) => {
        const newValue = e.target.value;
        setSelectedTransomOnLoose(newValue); // Update local state
        onChange(newValue); // Call onChange prop with the new value
    };

    return (
        <div className="a-container">
            <label  style={{ display: "none" }} htmlFor="TransomOnLoose">{label}</label>
            <select style={{ display: "none" }}
                id="TransomOnLoose"
                value={selectedTransomOnLoose}
                onChange={handleTransomOnLooseChange}
            >
              <option value="" disabled hidden>Select an option</option>  
              <option value="On">{selectedTransomOnLoose === "On" ? "On ✔" : "On"}</option>
              <option value="Loose">{selectedTransomOnLoose === "Loose" ? "Loose ✔" : "Loose"}</option>
            </select>
        </div>
    );
};

export default TransomOnLoose;
